<template>
  <svg width="146" height="95" viewBox="0 0 146 95" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M109.804 62.243V27.4017C109.804 22.4839 105.818 18.4973 100.9 18.4973H9.84097C4.92318 18.4973 0.936523 22.4839 0.936523 27.4017V84.6002C0.936523 89.518 4.92317 93.5046 9.84095 93.5046H100.9C105.818 93.5046 109.804 89.518 109.804 84.6002V62.3644"
      fill="none"
      stroke="#E2E4E8"
      stroke-width="1.87262"
      stroke-linecap="round"
    />
    <path d="M1.58008 31.3387H109.805" fill="none" stroke="#E2E4E8" stroke-width="1.87262" />
    <circle cx="9.5085" cy="25.9057" r="1.28584" fill="#293D66" />
    <circle cx="15.7233" cy="25.9057" r="1.28584" fill="#293D66" />
    <circle cx="21.7243" cy="25.9057" r="1.28584" fill="#293D66" />
    <path
      d="M36.0586 13.2294H144.937V66.7904C144.937 71.6397 141.005 75.5709 136.156 75.5709H44.8391C39.9898 75.5709 36.0586 71.6397 36.0586 66.7904V13.2294Z"
      fill="#FCFCFC"
    />
    <path
      d="M144.926 44.682V9.84075C144.926 4.92296 140.94 0.93631 136.022 0.93631H44.963C40.0452 0.93631 36.0586 4.92296 36.0586 9.84075V51.6107M144.926 44.8034V67.0392C144.926 71.957 140.94 75.9437 136.022 75.9437H44.963C40.0452 75.9437 36.0586 71.957 36.0586 67.0392V62.1775"
      fill="none"
      stroke="#293D66"
      stroke-width="1.87262"
      stroke-linecap="round"
    />
    <path d="M36.7012 13.7776H144.926" fill="none" stroke="#293D66" stroke-width="1.87262" />
    <circle cx="44.6306" cy="8.34477" r="1.28584" fill="#FF531A" />
    <circle cx="50.8454" cy="8.34477" r="1.28584" fill="#FF531A" />
    <circle cx="56.8464" cy="8.34477" r="1.28584" fill="#FF531A" />
    <path
      d="M18.7174 65.6498C18.0875 66.0135 17.8717 66.819 18.2354 67.4489C18.5991 68.0789 19.4046 68.2947 20.0345 67.931L19.376 66.7904L18.7174 65.6498ZM59.2823 44.8258C59.4706 44.1232 59.0536 43.401 58.351 43.2128L46.9013 40.1448C46.1986 39.9565 45.4764 40.3735 45.2882 41.0761C45.0999 41.7787 45.5169 42.5009 46.2195 42.6892L56.397 45.4163L53.67 55.5938C53.4817 56.2964 53.8987 57.0186 54.6013 57.2069C55.3039 57.3952 56.0261 56.9782 56.2144 56.2756L59.2823 44.8258ZM19.376 66.7904L20.0345 67.931L58.6687 45.6256L58.0101 44.485L57.3516 43.3443L18.7174 65.6498L19.376 66.7904Z"
      fill="#FF531A"
    />
  </svg>
</template>

<script lang="ts" setup></script>
